<template>
  <div id="container" class="l-container">
    <!-- Header ======================================== -->
    <header class="l-header">
      <p class="l-header-logo">
        <a href="/">
          <img
            src="../assets/images/common/logo_switch.png"
            alt="Nintendo Switch"
          />
        </a>
      </p>
    </header>
    <main class="l-content">
      <section class="mv">
        <div class="mv-header">
          <p class="mv-lead">
            <picture>
              <source
                srcset="../assets/images/coursepack/mv/mv_heading_sp.png"
                media="(max-width: 768px)"
              />
              <img src="../assets/images/coursepack/mv/mv_heading_pc.png" />
            </picture>
          </p>
        </div>
        <div class="mv-main">
          <div class="mv-main-hero">
            <picture>
              <source
                srcset="../assets/images/coursepack/mv/mv_hero_sp.jpg"
                media="(max-width: 768px)"
              />
              <img src="../assets/images/coursepack/mv/mv_hero_pc.jpg" alt="" />
            </picture>
          </div>
          <h1 class="mv-main-logo">
            <img src="../assets/images/coursepack/common/logo01.png" />
          </h1>
          <!-- <p class="mv-main-badge">
            <img src="../assets/images/coursepack/mv/mv_badge.png" />
          </p> -->
        </div>
        <div id="history" class="mv-history">
          <!-- 動画 -->
          <div class="mv-movie">
            <!-- <button
              type="button"
              class="mv-movie-button"
              @click="showVideo('b3367svqcdj')"
            > -->
            <button type="button" class="mv-movie-button" @click="toMoviePage">
              <span class="mv-movie-video">
                <video
                  src="../assets/videos/coursepack/mv_direct.mp4"
                  poster="../assets/movie/img/thumb/thumb-movie04.jpg"
                  webkit-playsinline
                  playsinline
                  x5-playsinline
                  muted
                  autoplay
                  loop
                ></video>
              </span>
              <span class="mv-movie-meta">
                <picture>
                  <source
                    srcset="
                      ../assets/images/coursepack/mv/mv_movie_label_frame_sp.png
                    "
                    media="(max-width: 768px)"
                  />
                  <img
                    src="../assets/images/coursepack/mv/mv_movie_label_frame_pc.png"
                    alt=""
                  />
                </picture>
                <span class="mv-movie-label">
                  <img
                    src="../assets/images/coursepack/mv/mv_movie_label01.png"
                  />
                </span>
              </span>
            </button>
          </div>
        </div>
      </section>
      <!-- Lineup ======================================== -->
      <section id="lineup" class="lineup">
        <div class="lineup-header">
          <p class="lineup-logo">
            <img src="../assets/images/coursepack/common/logo01.png" />
          </p>
          <div class="lineup-header-content">
            <!-- <p class="lineup-header-label">
              <img src="../assets/images/coursepack/lineup/lineup_label.png" />
            </p> -->
            <h2 class="lineup-header-desc">
              <img src="../assets/images/coursepack/lineup/lineup_desc.png" />
            </h2>
          </div>
        </div>
        <div class="lineup-body">
          <nav class="lineup-nav">
            <div class="lineup-nav-container">
              <ul class="lineup-nav-list">
                <li
                  v-for="(item, index) in volList"
                  :key="index"
                  class="lineup-nav-item"
                >
                  <button
                    type="button"
                    :class="{
                      'lineup-nav-action': true,
                      'is-active': index === currentIndex,
                      'is-coming-soon': !item.published
                    }"
                    :style="{ cursor: item.published ? 'pointer' : 'default' }"
                    @click="switchVol(index)"
                  >
                    <span v-if="item.published" class="lineup-nav-bg"></span>
                    <img
                      v-if="!item.published"
                      src="../assets/images/coursepack/lineup/lineup_nav_coming_soon.png"
                      class="lineup-nav-coming-soon"
                    />
                    <img :src="item.volImg" class="lineup-nav-label" />
                    <span v-if="item.published" class="lineup-nav-bar"></span>
                  </button>
                </li>
              </ul>
            </div>
          </nav>
          <div class="lineup-vol" style="height: auto;">
            <div class="lineup-vol-list" >
              <div
                v-for="(item, index) in volList"
                :key="index"
                :class="{
                  'lineup-vol-item': true,
                  'is-active': currentIndex === index
                }"
                :id="item.sectionId || ''"
              >
                <template v-if="item.published">
                  <h3 class="lineup-vol-release">
                    <span class="lineup-vol-release-inner">
                      <img :src="item.headingImg" />
                    </span>
                  </h3>
                  <div class="lineup-cup-list">
                    <section
                      v-for="(match, mIndex) in item.match"
                      :key="mIndex"
                      class="lineup-cup-item"
                    >
                      <div class="lineup-cup-header">
                        <figure class="lineup-cup-badge">
                          <img :src="match.badgeImg" />
                        </figure>
                        <h4 class="lineup-cup-name">
                          <img :src="match.badgeNameImg" />
                        </h4>
                      </div>
                      <ul class="lineup-course-list">
                        <li
                          v-for="(round, rIndex) in match.round"
                          :key="rIndex"
                          class="lineup-course-item"
                        >
                          <button
                            type="button"
                            class="lineup-course-button"
                            @click="showGallery(index, mIndex, rIndex)"
                          >
                            <img
                              style="opacity: 1;"
                              :src="round.img"
                              class="lineup-course-thumb"
                            />
                            <img
                              :src="round.label"
                              class="lineup-course-label"
                            />
                          </button>
                        </li>
                      </ul>
                    </section>
                  </div>
                  <div v-if="item.character && item.character.length" class="lineup-cup-item">
                    <div id="character" class="lineup-4th-bullet">
                      <div v-for="(character,index) in item.character" :key="index" class="lineup-4th-bullet-flex">
                        <div class="chara_text">
                          <section>
                            <p class="shoulder-title" v-if="character.shoulderImg">
                              <img :src="character.shoulderImg" />
                            </p>

                            <h4>
                              <picture>
                                <source
                                  :srcset="character.nameMobileImg"
                                  media="(max-width: 768px)"
                                />
                                <img :src="character.nameImg" />
                              </picture>
                            </h4>
                          </section>

                          <p class="caption">
                            <picture>
                              <source
                                :srcset="character.text1MobileImg"
                                media="(max-width: 768px)"
                              />
                              <img :src="character.text1Img" />
                            </picture>
                          </p>
                          <div class="none768">
                            <ul>
                              <li>
                                <img :src="character.poster1" />
                              </li>
                              <li>
                                <img :src="character.poster2" />
                              </li>
                            </ul>
                          </div>
                        </div>

                        <div class="lineup-cup-character">
                          <picture>
                            <source
                              :srcset="character.mainMobileImg"
                              media="(max-width: 768px)"
                            />
                            <img :src="character.mainImg" />
                          </picture>
                        </div>

                        <div class="block768">
                          <ul>
                            <li>
                              <img :src="character.poster1" />
                            </li>
                            <li>
                              <img :src="character.poster2" alt="" />
                            </li>
                          </ul>
                        </div>
                      </div>

                      <p class="lineup-text" v-if="item.text2Img">
                        <picture>
                          <source
                            :srcset="item.text2MobileImg"
                            media="(max-width: 768px)"
                          />
                          <img :src="item.text2Img" />
                        </picture>
                      </p>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="lineup-notice">
            <ul class="lineup-notice-list">
              <li class="lineup-notice-item c-notice">
                各赛道或杯赛不做单独发售。
              </li>
            </ul>
          </div>
        </div>
      </section>
      <!-- Info ======================================== -->
      <div class="info">
        <div class="info-bg"></div>
        <div class="info-container">
          <!-- Product ======================================== -->
          <section
            id="product"
            class="product js-purchase-end"
            data-purchase-trigger="80%"
          >
            <div class="product-container">
              <div class="product-header">
                <div class="product-header-hero">
                  <p class="product-header-package">
                    <img
                      src="../assets/images/coursepack/product/product_package.png"
                    />
                  </p>
                </div>
                <div class="product-header-content">
                  <h2 class="product-header-heading">
                    <picture>
                      <source
                        srcset="
                          ../assets/images/coursepack/product/product_heading1_sp.png
                        "
                        media="(max-width: 768px)"
                      />
                      <img
                        src="../assets/images/coursepack/product/product_heading1_pc.png"
                      />
                    </picture>
                  </h2>
                  <p class="product-header-desc">
                    <picture>
                      <source
                        srcset="
                          ../assets/images/coursepack/product/product_desc_sp1.png
                        "
                        media="(max-width: 768px)"
                      />
                      <img
                        src="../assets/images/coursepack/product/product_desc1_pc.png"
                      />
                    </picture>
                  </p>
                </div>
              </div>
              <div class="product-header">
                <div class="product-header-hero">
                  <p class="product-header-package">
                    <img
                      src="../assets/images/coursepack/product/product_package2.png"
                    />
                  </p>
                </div>
                <div class="product-header-content">
                  <h2 class="product-header-heading">
                    <picture>
                      <source
                        srcset="
                          ../assets/images/coursepack/product/product_heading2_sp.png
                        "
                        media="(max-width: 768px)"
                      />
                      <img
                        src="../assets/images/coursepack/product/product_heading2_pc.png"
                      />
                    </picture>
                  </h2>
                  <p class="product-header-desc">
                    <picture>
                      <source
                        srcset="
                          ../assets/images/coursepack/product/product_desc_sp2.png
                        "
                        media="(max-width: 768px)"
                      />
                      <img
                        src="../assets/images/coursepack/product/product_desc2_pc.png"
                      />
                    </picture>
                  </p>
                </div>
              </div>
              <ul class="product-notice">
                <li class="product-notice-item c-notice">
                  要游玩此新增内容，需要《马力欧卡丁车8
                  豪华版》正篇的游戏软件(另售)。
                </li>
                <li class="product-notice-item c-notice">
                  和《马力欧卡丁车8
                  豪华版》收录的其他赛道一样，《新增赛道通行证》收录的赛道也可在「多人」、<br
                    class="u-display-sp"
                  />「网络联机」、「本地联机」中游玩。
                </li>
              </ul>
              <div class="btns-box">
                <buy-btn :urls="buyList" :text="'前往购买'"></buy-btn>
              </div>
            </div>
            <div class="product-chara">
              <div class="product-chara-01">
                <div class="product-chara-image"></div>
              </div>
              <div class="product-chara-02">
                <div class="product-chara-image"></div>
              </div>
              <div class="product-chara-03">
                <div class="product-chara-image"></div>
              </div>
            </div>
          </section>
          <!-- Q&A ======================================== -->
          <section id="faq" class="faq">
            <h2 class="faq-heading">
              <img src="../assets/images/coursepack/faq/faq_heading.png" />
            </h2>
            <div class="faq-list">
              <!-- Q1 -->
              <div class="faq-item">
                <div class="faq-item-container">
                  <button
                    type="button"
                    class="faq-question qusetion js-hover-button"
                    data-hover="rotate-180"
                  >
                    <span class="faq-question-content">
                      <p>
                        购买付费新增内容《马力欧卡丁车8 豪华版
                        新增赛道通行证》后，有哪些用户可以游玩?
                      </p>
                    </span>
                  </button>
                  <button
                    type="button"
                    class="faq-question answer js-hover-button"
                    data-hover="rotate-180"
                  >
                    <span class="faq-question-content">
                      <p>购买者、和购买者使用同一台主机的用户。</p>
                      <p>
                        如持有2台或以上Nintendo
                        Switch，使用“随时游玩的主机”以外的主机游玩时，只有购买者可以游玩。
                      </p>
                    </span>
                  </button>
                </div>
              </div>
              <!-- Q2 -->
              <div class="faq-item">
                <div class="faq-item-container">
                  <button
                    type="button"
                    class="faq-question qusetion js-hover-button"
                    data-hover="rotate-180"
                  >
                    <span class="faq-question-content">
                      <p>
                        购买《马力欧卡丁车8 豪华版
                        新增赛道通行证》后，即使没有购买《马力欧卡丁车8
                        豪华版》也可以进行游玩吗?
                      </p>
                    </span>
                  </button>
                  <button
                    type="button"
                    class="faq-question answer js-hover-button"
                    data-hover="rotate-180"
                  >
                    <span class="faq-question-content">
                      <p>
                        要游玩《马力欧卡丁车8 豪华版
                        新增赛道通行证》，需要《马力欧卡丁车8
                        豪华版》正篇的游戏软件(另售)。
                      </p>
                    </span>
                  </button>
                </div>
              </div>
              <!-- Q3 -->
              <div class="faq-item">
                <div class="faq-item-container">
                  <button
                    type="button"
                    class="faq-question qusetion js-hover-button"
                    data-hover="rotate-180"
                  >
                    <span class="faq-question-content">
                      <p>
                        启动《马力欧卡丁车8
                        豪华版》后无法游玩《新增赛道通行证》是什么原因？
                      </p>
                    </span>
                  </button>
                  <button
                    type="button"
                    class="faq-question answer js-hover-button"
                    data-hover="rotate-180"
                  >
                    <span class="faq-question-content">
                      <p>
                        <i class="embellish">※</i>请确认《马力欧卡丁车8
                        豪华版》是否已经升级到Ver.2.1.0或更高版本，以及《新增赛道通行证》是否已经下载到Nintendo
                        Switch本体中。
                      </p>
                      <p>
                        <i class="embellish">※</i
                        >请确认是否使用购买了《新增赛道通行证》的用户启动《马力欧卡丁车8
                        豪华版》。
                      </p>
                      <p>
                        <i class="embellish">※</i
                        >使用进行了购买操作以外的Nintendo
                        Switch游玩的话，请在e商店右上角的账户信息中点击“重新下载”找到《新增赛道通行证》并重新下载
                        。
                      </p>
                    </span>
                  </button>
                </div>
              </div>
              <!-- Q3 -->
              <div class="faq-item">
                <div class="faq-item-container">
                  <button
                    type="button"
                    class="faq-question qusetion js-hover-button"
                    data-hover="rotate-180"
                  >
                    <span class="faq-question-content">
                      <p>
                        和没有购买《马力欧卡丁车8 豪华版
                        新增赛道通行证》的用户，可以对战收录在《马力欧卡丁车8
                        豪华版 新增赛道通行证》的赛道吗?
                      </p>
                    </span>
                  </button>
                  <button
                    type="button"
                    class="faq-question answer js-hover-button"
                    data-hover="rotate-180"
                  >
                    <span class="faq-question-content">
                      <p><i class="embellish">※</i>「多人」的场合</p>
                      <p>
                        《新增赛道通行证》的购买者启动游戏的时候，所有用户可以游玩《新增赛道通行证》收录的赛道。
                      </p>
                      <p><i class="embellish">※</i>「网络联机」的场合</p>
                      <p>
                        在「好友或劲敌」，一起游玩的成员中有1人或以上是《新增赛道通行证》的购买者，所有成员可一同游玩收录在「新增赛道通行证」的赛道。
                      </p>
                      <p>
                        另外，于2022年9月26日后，在「区域」或「大赛」选择赛道时，《新增赛道通行证》的赛道有可能随机出现。
                      </p>
                      <p><i class="embellish">※</i>「本地联机」的场合</p>
                      <p>
                        一起游玩的成员中有1人或以上是《新增赛道通行证》的购买者。所有成员可以游玩《新增赛道通行证》收录的赛道。
                      </p>
                    </span>
                  </button>
                </div>
              </div>
              <!-- Q4 -->
              <div class="faq-item">
                <div class="faq-item-container">
                  <button
                    type="button"
                    class="faq-question qusetion js-hover-button"
                    data-hover="rotate-180"
                  >
                    <span class="faq-question-content">
                      <p>
                        购买《马力欧卡丁车8 豪华版
                        新增赛道通行证》后，在没有连接网络的情况下可以游玩吗?
                      </p>
                    </span>
                  </button>
                  <button
                    type="button"
                    class="faq-question answer js-hover-button"
                    data-hover="rotate-180"
                  >
                    <span class="faq-question-content">
                      <p>没有网络的地方也可以游玩。</p>
                    </span>
                  </button>
                </div>
              </div>
              <!-- Q5 -->
              <div class="faq-item">
                <div class="faq-item-container">
                  <button
                    type="button"
                    class="faq-question qusetion js-hover-button"
                    data-hover="rotate-180"
                  >
                    <span class="faq-question-content">
                      <p>
                        要游玩《马力欧卡丁车8 豪华版
                        新增赛道通行证》时，必须把《马力欧卡丁车8
                        豪华版》游玩到某个进度吗?
                      </p>
                    </span>
                  </button>
                  <button
                    type="button"
                    class="faq-question answer js-hover-button"
                    data-hover="rotate-180"
                  >
                    <span class="faq-question-content">
                      <p>从一开始就可以游玩。</p>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <!-- Outro ======================================== -->
      <div class="outro">
        <p class="outro-button">
          <a
            href="../index.html"
            class="outro-button-link js-hover-button"
            data-hover="jump"
          >
            <span class="outro-button-link-inner js-hover-button-child">
              <picture>
                <source
                  srcset="
                    ../assets/images/coursepack/outro/outro_button01_pc.png
                  "
                  media="(max-width: 768px)"
                />
                <img
                  src="../assets/images/coursepack/outro/outro_button01_pc.png"
                />
              </picture>
            </span>
          </a>
        </p>
      </div>
      <!-- Movie Modal ======================================== -->
      <!-- 显示添加类名：is-active is-entered
      行内样式style  display:flex; -->
      <div
        :class="{
          'c-modal': true,
          movie: true,
          displayFlex: show.video,
          'is-active': show.video2,
          'is-entered': show.video
        }"
        @click="closeVideo"
      >
        <div
          id="videobox"
          class="c-modal-frame movie-frame"
          :style="autoFixVideoStyle"
          @click.stop
        ></div>
        <button
          type="button"
          class="c-modal-close js-hover-button"
          data-hover="rotate-90"
          @click="closeVideo"
        >
          <img
            src="../assets/images/coursepack/modal/modal_close_bg.png"
            alt=""
          />
          <span class="c-modal-close-icon js-hover-button-child">
            <img src="../assets/images/coursepack/modal/modal_close_icon.png" />
          </span>
        </button>
      </div>
      <!-- Course Modal ======================================== -->
      <!-- 显示添加类名：is-active is-entered
      行内样式style  display:flex; -->
      <div
        class="c-modal course"
        :class="{
          displayFlex: show.gallery,
          'is-active': show.gallery2,
          'is-entered': show.gallery
        }"
        @click="closeGallery"
      >
        <div class="c-modal-frame course-frame" @click.stop>
          <swiper
            id="course-container"
            ref="mySwiper"
            class="course-container"
            :options="swiperOption"
            @slideChange="slideChangeHandler"
          >
            <swiper-slide v-for="(item, index) in galleryList" :key="index">
              <div
                data-media="video"
                class="course-item"
                @click="playGalleryVideo(index)"
              >
                <div class="course-player swiper-no-swiping">
                  <div
                    :id="'gallery-vid-' + item.vid + '-' + index"
                    style="height: 100%; width: 100%;"
                  ></div>
                </div>
                <button
                  class="course-cover course-cover-with-player"
                  :style="{
                    opacity: currentPlayingVideo === index ? 0 : 1,
                    visibility:
                      currentPlayingVideo === index ? 'hidden' : 'visible'
                  }"
                >
                  <img style="opacity: 1;" :src="item.img" alt="" />
                  <span class="course-cover-icon">
                    <img
                      src="../assets/images/coursepack/modal/modal_play.png"
                    />
                  </span>
                </button>
                <p class="course-name">{{ item.name }}</p>
              </div>
            </swiper-slide>
            <button
              v-if="showPrev"
              slot="button-prev"
              type="button"
              class="course-nav-prev js-hover-button"
              data-hover="left"
              @click="prevHandler"
            >
              <span class="course-nav-icon js-hover-button-child">
                <img
                  src="../assets/images/coursepack/modal/modal_arrow_left.png"
                  alt=""
                />
              </span>
            </button>
            <button
              v-if="showNext"
              slot="button-next"
              type="button"
              class="course-nav-next js-hover-button"
              data-hover="right"
              @click="nextHandler"
            >
              <span class="course-nav-icon js-hover-button-child">
                <img
                  src="../assets/images/coursepack/modal/modal_arrow_right.png"
                  alt=""
                />
              </span>
            </button>
          </swiper>
        </div>
        <button
          type="button"
          class="c-modal-close js-hover-button"
          data-hover="rotate-90"
          @click="closeGallery"
        >
          <img
            src="../assets/images/coursepack/modal/modal_close_bg.png"
            alt=""
          />
          <span class="c-modal-close-icon js-hover-button-child">
            <img
              src="../assets/images/coursepack/modal/modal_close_icon.png"
              alt=""
            />
          </span>
        </button>
      </div>
    </main>
    <!-- Footer ======================================== -->
    <div class="footers">
      <p class="footers-des">
        <span class="footers-des-item">©2022 Nintendo</span><i>|</i
        ><span class="footers-des-item"
          ><a
            href="https://game.qq.com/self-discipline_pact.shtml"
            target="_blank"
            >©网络游戏行业防沉迷自律公约</a
          ></span
        >
      </p>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import '../assets/css/movie.css';
import '../assets/css/coursepack.css';
import { pgvEventReport } from './tcss-report';
import { queryCdnData } from './api';
import buyBtn from './components/buy-btn.vue';
function getScrollbarWidth() {
  return (
    window.innerWidth - document.getElementsByTagName('html')[0].offsetWidth
  );
}
export default {
  components: {
    buyBtn,
    swiper,
    swiperSlide
  },
  data() {
    return {
      isMobile: false,
      isIOS: false,
      show: {
        video: false,
        gallery: false,
        video2: false, // is-active class需要延时加载才能展示动画
        gallery2: false,
        prev: false,
        next: false
      },
      tempTop: 0, // ios 浮层锁定滚动条记录高度
      currentIndex: 4,
      currentSwiper: 0,
      currentPlayingVideo: -1,
      gallery: {}, // 缓存
      galleryList: [],
      volList: [
        {
          published: true,
          volImg: require('@/../assets/images/coursepack/lineup/vol01/vol01_nav_index.png'),
          headingImg: require('@/../assets/images/coursepack/lineup/vol01/vol01_heading.png'),
          match: [
            {
              badgeImg: require('@/../assets/images/coursepack/lineup/vol01/vol01_cup01_badge.png'),
              badgeNameImg: require('@/../assets/images/coursepack/lineup/vol01/vol01_cup01_name.png'),
              round: [
                {
                  img: require('@/../assets/images/coursepack/lineup/vol01/vol01_cup01_cover01.jpg'),
                  label: require('@/../assets/images/coursepack/lineup/vol01/vol01_cup01_label01.png'),
                  vid: 'b3356c54rnd',
                  name: '巴黎兜风'
                },
                {
                  img: require('@/../assets/images/coursepack/lineup/vol01/vol01_cup01_cover02.jpg'),
                  label: require('@/../assets/images/coursepack/lineup/vol01/vol01_cup01_label02.png'),
                  vid: 'c3356uoexjj',
                  name: '3DS 奇诺比奥赛道'
                },
                {
                  img: require('@/../assets/images/coursepack/lineup/vol01/vol01_cup01_cover03.jpg'),
                  label: require('@/../assets/images/coursepack/lineup/vol01/vol01_cup01_label03.png'),
                  vid: 't33567op8gr',
                  name: 'N64 巧克力山'
                },
                {
                  img: require('@/../assets/images/coursepack/lineup/vol01/vol01_cup01_cover04.jpg'),
                  label: require('@/../assets/images/coursepack/lineup/vol01/vol01_cup01_label04.png'),
                  vid: 'u3356t50y6g',
                  name: 'Wii 椰子广场'
                }
              ]
            },
            {
              badgeImg: `${require('@/../assets/images/coursepack/lineup/vol01/vol01_cup02_badge.png')}?imageMogr2/format/png`,
              badgeNameImg: require('@/../assets/images/coursepack/lineup/vol01/vol01_cup02_name.png'),
              round: [
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol01/vol01_cup02_cover01.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol01/vol01_cup02_label01.png'),
                  vid: 'p33562fljqp',
                  name: '东京赛道'
                },
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol01/vol01_cup02_cover02.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol01/vol01_cup02_label02.png'),
                  vid: 'c3356mngiw3',
                  name: 'DS 蘑菇山脊路'
                },
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol01/vol01_cup02_cover03.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol01/vol01_cup02_label03.png'),
                  vid: 'n33566vn0ic',
                  name: 'GBA 空中花园'
                },
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol01/vol01_cup02_cover04.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol01/vol01_cup02_label04.png'),
                  vid: 'm3356ijoa5t',
                  name: '忍者道场'
                }
              ]
            }
          ]
        },
        {
          published: true,
          volImg: require('@/../assets/images/coursepack/lineup/vol02/vol02_nav_index.png'),
          headingImg: require('@/../assets/images/coursepack/lineup/vol02/vol02_heading.png'),
          match: [
            {
              badgeImg: `${require('@/../assets/images/coursepack/lineup/vol02/vol02_cup01_badge.png')}?imageMogr2/format/png`,
              badgeNameImg: require('@/../assets/images/coursepack/lineup/vol02/vol02_cup01_name.png'),
              round: [
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol02/vol02_cup01_cover01.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol02/vol02_cup01_label01.png'),
                  vid: 'z3356inc3nh',
                  name: '纽约分钟'
                },
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol02/vol02_cup01_cover02.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol02/vol02_cup01_label02.png'),
                  vid: 'r3356zobsrt',
                  name: 'SFC 马力欧赛道3'
                },
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol02/vol02_cup01_cover03.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol02/vol02_cup01_label03.png'),
                  vid: 'z3356aawt9v',
                  name: 'N64 干旱沙漠'
                },
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol02/vol02_cup01_cover04.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol02/vol02_cup01_label04.png'),
                  vid: 'r335608drxu',
                  name: 'DS 瓦路易吉弹珠台'
                }
              ]
            },
            {
              badgeImg: `${require('@/../assets/images/coursepack/lineup/vol02/vol02_cup02_badge.png')}?imageMogr2/format/png`,
              badgeNameImg: require('@/../assets/images/coursepack/lineup/vol02/vol02_cup02_name.png'),
              round: [
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol02/vol02_cup02_cover01.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol02/vol02_cup02_label01.png'),
                  vid: 'w3356gmbmnl',
                  name: '悉尼冲刺'
                },
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol02/vol02_cup02_cover02.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol02/vol02_cup02_label02.png'),
                  vid: 'h3356n78tez',
                  name: 'GBA 白雪天地'
                },
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol02/vol02_cup02_cover03.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol02/vol02_cup02_label03.png'),
                  vid: 'b3356q2jb6y',
                  name: 'Wii 蘑菇峡谷'
                },
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol02/vol02_cup02_cover04.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol02/vol02_cup02_label04.png'),
                  vid: 'f3356yr4f9v',
                  name: '冰品摩天楼'
                }
              ]
            }
          ]
        },
        {
          published: true,
          volImg: require('@/../assets/images/coursepack/lineup/vol03/vol03_nav_index.png'),
          headingImg: require('@/../assets/images/coursepack/lineup/vol03/vol03_heading.png'),
          match: [
            {
              badgeImg: require('@/../assets/images/coursepack/lineup/vol03/vol03_cup01_badge.png'),
              badgeNameImg: require('@/../assets/images/coursepack/lineup/vol03/vol03_cup01_name.png'),
              round: [
                {
                  img: require('@/../assets/images/coursepack/lineup/vol03/vol03_cup01_cover01.jpg'),
                  label: require('@/../assets/images/coursepack/lineup/vol03/vol03_cup01_label01.png'),
                  vid: 'n3367ieqrf1',
                  name: '伦敦环线'
                },
                {
                  img: require('@/../assets/images/coursepack/lineup/vol03/vol03_cup01_cover02.jpg'),
                  label: require('@/../assets/images/coursepack/lineup/vol03/vol03_cup01_label02.png'),
                  vid: 'k3367ux0zb1',
                  name: 'GBA 害羞幽灵湖'
                },
                {
                  img: require('@/../assets/images/coursepack/lineup/vol03/vol03_cup01_cover03.jpg'),
                  label: require('@/../assets/images/coursepack/lineup/vol03/vol03_cup01_label03.png'),
                  vid: 'p3367kb9w1f',
                  name: '3DS 岩岩山'
                },
                {
                  img: require('@/../assets/images/coursepack/lineup/vol03/vol03_cup01_cover04.jpg'),
                  label: require('@/../assets/images/coursepack/lineup/vol03/vol03_cup01_label04.png'),
                  vid: 'a33676fxmxc',
                  name: 'Wii 枫树屋'
                }
              ]
            },
            {
              badgeImg: require('@/../assets/images/coursepack/lineup/vol03/vol03_cup02_badge.png'),
              badgeNameImg: require('@/../assets/images/coursepack/lineup/vol03/vol03_cup02_name.png'),
              round: [
                {
                  img: require('@/../assets/images/coursepack/lineup/vol03/vol03_cup02_cover01.jpg'),
                  label: require('@/../assets/images/coursepack/lineup/vol03/vol03_cup02_label01.png'),
                  vid: 'y33674co5s5',
                  name: '柏林小道'
                },
                {
                  img: require('@/../assets/images/coursepack/lineup/vol03/vol03_cup02_cover02.jpg'),
                  label: require('@/../assets/images/coursepack/lineup/vol03/vol03_cup02_label02.png'),
                  vid: 'm3367bq3unu',
                  name: 'DS 桃花公主公园'
                },
                {
                  img: require('@/../assets/images/coursepack/lineup/vol03/vol03_cup02_cover04.jpg'),
                  label: require('@/../assets/images/coursepack/lineup/vol03/vol03_cup02_label04.png'),
                  vid: 'i33676wpk75',
                  name: '欢乐山'
                },
                {
                  img: require('@/../assets/images/coursepack/lineup/vol03/vol03_cup02_cover03.jpg'),
                  label: require('@/../assets/images/coursepack/lineup/vol03/vol03_cup02_label03.png'),
                  vid: 'x3367q5em0i',
                  name: '3DS 彩虹之路'
                }
              ]
            }
          ]
        },
        {
          published: true,
          volImg: require('@/../assets/images/coursepack/lineup/vol04/vol04_nav_index.png'),
          headingImg: require('@/../assets/images/coursepack/lineup/vol04/vol04_heading.png'),
          match: [
            {
              badgeImg: require('@/../assets/images/coursepack/lineup/vol04/vol04_cup01_badge.png'),
              badgeNameImg: require('@/../assets/images/coursepack/lineup/vol04/vol04_cup01_name.png'),
              round: [
                {
                  img: require('@/../assets/images/coursepack/lineup/vol04/vol04_cup01_cover01.jpg'),
                  label: require('@/../assets/images/coursepack/lineup/vol04/vol04_cup01_label01.png'),
                  vid: 'x3509dnsr17',
                  name: '阿姆斯特丹漂流'
                },
                {
                  img: require('@/../assets/images/coursepack/lineup/vol04/vol04_cup01_cover02.jpg'),
                  label: require('@/../assets/images/coursepack/lineup/vol04/vol04_cup01_label02.png'),
                  vid: 'x3509h158qu',
                  name: 'GBA 河岸公园'
                },
                {
                  img: require('@/../assets/images/coursepack/lineup/vol04/vol04_cup01_cover03.jpg'),
                  label: require('@/../assets/images/coursepack/lineup/vol04/vol04_cup01_label03.png'),
                  vid: 'd3509na9ktn',
                  name: 'Wii DK单板滑雪障碍追逐'
                },
                {
                  img: require('@/../assets/images/coursepack/lineup/vol04/vol04_cup01_cover04.jpg'),
                  label: require('@/../assets/images/coursepack/lineup/vol04/vol04_cup01_label04.png'),
                  vid: 'x3509co4k7b',
                  name: '耀西岛'
                }
              ]
            },
            {
              badgeImg: require('@/../assets/images/coursepack/lineup/vol04/vol04_cup02_badge.png'),
              badgeNameImg: require('@/../assets/images/coursepack/lineup/vol04/vol04_cup02_name.png'),
              round: [
                {
                  img: require('@/../assets/images/coursepack/lineup/vol04/vol04_cup02_cover01.jpg'),
                  label: require('@/../assets/images/coursepack/lineup/vol04/vol04_cup02_label01.png'),
                  vid: 'a3509tqprm6',
                  name: '曼谷飙速'
                },
                {
                  img: require('@/../assets/images/coursepack/lineup/vol04/vol04_cup02_cover02.jpg'),
                  label: require('@/../assets/images/coursepack/lineup/vol04/vol04_cup02_label02.png'),
                  vid: 't3509fbzygx',
                  name: 'DS 马力欧赛道'
                },
                {
                  img: require('@/../assets/images/coursepack/lineup/vol04/vol04_cup02_cover04.jpg'),
                  label: require('@/../assets/images/coursepack/lineup/vol04/vol04_cup02_label04.png'),
                  vid: 't3509zeexjo',
                  name: 'GC 瓦路易吉竞技场'
                },
                {
                  img: require('@/../assets/images/coursepack/lineup/vol04/vol04_cup02_cover03.jpg'),
                  label: require('@/../assets/images/coursepack/lineup/vol04/vol04_cup02_label03.png'),
                  vid: 'b3509xfvsw0',
                  name: '新加坡竞速赛道'
                }
              ]
            }
          ],
          text2Img: require('@/../assets/images/coursepack/lineup/vol04/vol04_character_text02.png'),
          text2MobileImg: require('@/../assets/images/coursepack/lineup/vol04/vol04_character_text02_sp.png'),
          sectionId: "lineup-4th",
          character: [{
            shoulderImg: require('@/../assets/images/coursepack/lineup/vol04/vol04_character_shoulder.png'),
            nameMobileImg: require('@/../assets/images/coursepack/lineup/vol04/vol04_character_name_sp.png'),
            nameImg: require('@/../assets/images/coursepack/lineup/vol04/vol04_character_name.png'),
            text1MobileImg: require('@/../assets/images/coursepack/lineup/vol04/vol04_character_text01_sp.png'),
            text1Img: require('@/../assets/images/coursepack/lineup/vol04/vol04_character_text01.png'),
            poster1: require('@/../assets/images/coursepack/lineup/vol04/vol04_character_thumb01.png'),
            poster2: require('@/../assets/images/coursepack/lineup/vol04/vol04_character_thumb02.png'),
            mainMobileImg: require('@/../assets/images/coursepack/lineup/vol04/vol04_character_img01_sp.png'),
            mainImg: require('@/../assets/images/coursepack/lineup/vol04/vol04_character_img01.png')
          }]
        },
        {
          published: true,
          volImg: require('@/../assets/images/coursepack/lineup/vol05/vol05_nav_index.png'),
          headingImg: require('@/../assets/images/coursepack/lineup/vol05/vol05_heading.png'),
          match: [
          {
              badgeImg: `${require('@/../assets/images/coursepack/lineup/vol05/vol05_cup01_badge.png')}?imageMogr2/format/png`,
              badgeNameImg: require('@/../assets/images/coursepack/lineup/vol05/vol05_cup01_name.png'),
              round: [
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol05/vol05_cup01_cover01.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol05/vol05_cup01_label01.png'),
                  vid: 'a3536bbt88o',
                  name: '雅典城邦'
                },
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol05/vol05_cup01_cover02.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol05/vol05_cup01_label02.png'),
                  vid: 'x3536pdh2nj',
                  name: 'GC 菊花公主游轮'
                },
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol05/vol05_cup01_cover03.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol05/vol05_cup01_label03.png'),
                  vid: 'f3536k2nhsc',
                  name: 'Wii 月下山脊&公路'
                },
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol05/vol05_cup01_cover04.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol05/vol05_cup01_label04.png'),
                  vid: 'b3536hh2s4u',
                  name: '肥皂泡之路'
                }
              ]
            },
            {
              badgeImg: `${require('@/../assets/images/coursepack/lineup/vol05/vol05_cup02_badge.png')}?imageMogr2/format/png`,
              badgeNameImg: require('@/../assets/images/coursepack/lineup/vol05/vol05_cup02_name.png'),
              round: [
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol05/vol05_cup02_cover01.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol05/vol05_cup02_label01.png'),
                  vid: 'z3536uv7uv1',
                  name: '洛杉矶环圈'
                },
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol05/vol05_cup02_cover02.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol05/vol05_cup02_label02.png'),
                  vid: 'f3536nq1rq5',
                  name: 'GBA 日落荒野'
                },
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol05/vol05_cup02_cover03.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol05/vol05_cup02_label03.png'),
                  vid: 'q35367vrwkh',
                  name: 'Wii 慢慢龟海角'
                },
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol05/vol05_cup02_cover04.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol05/vol05_cup02_label04.png'),
                  vid: 'i3536avezt2',
                  name: '温哥华速度'
                }
              ]
            }
          ],
          sectionId: "lineup-5th",
          character: [
            {
              shoulderImg: require('@/../assets/images/coursepack/lineup/vol04/vol04_character_shoulder.png'),
              nameMobileImg: require('@/../assets/images/coursepack/lineup/vol05/vol05_character_name1_sp.png'),
              nameImg: require('@/../assets/images/coursepack/lineup/vol05/vol05_character_name1.png'),
              text1MobileImg: require('@/../assets/images/coursepack/lineup/vol05/vol05_character_text01_sp.png'),
              text1Img: require('@/../assets/images/coursepack/lineup/vol05/vol05_character_text01.png'),
              poster1: require('@/../assets/images/coursepack/lineup/vol05/vol05_character_thumb01.png'),
              poster2: require('@/../assets/images/coursepack/lineup/vol05/vol05_character_thumb02.png'),
              mainMobileImg: require('@/../assets/images/coursepack/lineup/vol05/vol05_character_img01_sp.png'),
              mainImg: require('@/../assets/images/coursepack/lineup/vol05/vol05_character_img01.png')
            },
            {
              nameMobileImg: require('@/../assets/images/coursepack/lineup/vol05/vol05_character_name2_sp.png'),
              nameImg: require('@/../assets/images/coursepack/lineup/vol05/vol05_character_name2.png'),
              text1MobileImg: require('@/../assets/images/coursepack/lineup/vol05/vol05_character_text01_sp.png'),
              text1Img: require('@/../assets/images/coursepack/lineup/vol05/vol05_character_text01.png'),
              poster1: require('@/../assets/images/coursepack/lineup/vol05/vol05_character_thumb03.png'),
              poster2: require('@/../assets/images/coursepack/lineup/vol05/vol05_character_thumb04.png'),
              mainMobileImg: require('@/../assets/images/coursepack/lineup/vol05/vol05_character_img02_sp.png'),
              mainImg: require('@/../assets/images/coursepack/lineup/vol05/vol05_character_img02.png')
            },
            {
              nameMobileImg: require('@/../assets/images/coursepack/lineup/vol05/vol05_character_name3_sp.png'),
              nameImg: require('@/../assets/images/coursepack/lineup/vol05/vol05_character_name3.png'),
              text1MobileImg: require('@/../assets/images/coursepack/lineup/vol05/vol05_character_text02_sp.png'),
              text1Img: require('@/../assets/images/coursepack/lineup/vol05/vol05_character_text02.png'),
              poster1: require('@/../assets/images/coursepack/lineup/vol05/vol05_character_thumb05.png'),
              poster2: require('@/../assets/images/coursepack/lineup/vol05/vol05_character_thumb06.png'),
              mainMobileImg: require('@/../assets/images/coursepack/lineup/vol05/vol05_character_img03_sp.png'),
              mainImg: require('@/../assets/images/coursepack/lineup/vol05/vol05_character_img03.png')
            }
          ]
        },
        {
          published: true,
          volImg: require('@/../assets/images/coursepack/lineup/vol06/vol06_nav_index.png'),
          headingImg: require('@/../assets/images/coursepack/lineup/vol06/vol06_heading.png'),
          match: [
          {
              badgeImg: `${require('@/../assets/images/coursepack/lineup/vol06/vol06_cup01_badge.png')}?imageMogr2/format/png`,
              badgeNameImg: require('@/../assets/images/coursepack/lineup/vol06/vol06_cup01_name.png'),
              round: [
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol06/vol06_cup01_cover01.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol06/vol06_cup01_label01.png'),
                  vid: 'r3536pbrtlr',
                  name: '罗马前进'
                },
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol06/vol06_cup01_cover02.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol06/vol06_cup01_label02.png'),
                  vid: 'x3536yahruh',
                  name: 'GC DK山'
                },
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol06/vol06_cup01_cover03.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol06/vol06_cup01_label03.png'),
                  vid: 'x3536omht1y',
                  name: 'Wii 菊花公主赛道'
                },
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol06/vol06_cup01_cover04.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol06/vol06_cup01_label04.png'),
                  vid: 'i35369ivcre',
                  name: '吞食花神殿'
                }
              ]
            },
            {
              badgeImg: `${require('@/../assets/images/coursepack/lineup/vol06/vol06_cup02_badge.png')}?imageMogr2/format/png`,
              badgeNameImg: require('@/../assets/images/coursepack/lineup/vol06/vol06_cup02_name.png'),
              round: [
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol06/vol06_cup02_cover01.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol06/vol06_cup02_label01.png'),
                  vid: 'f3536ht048k',
                  name: '马德里圣殿'
                },
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol06/vol06_cup02_cover02.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol06/vol06_cup02_label02.png'),
                  vid: 'l3536vrei4z',
                  name: '3DS 罗莎塔行星'
                },
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol06/vol06_cup02_cover03.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol06/vol06_cup02_label04.png'),
                  vid: 'c3536ofw3pc',
                  name: 'SFC 酷霸王城堡3'
                },
                {
                  img: `${require('@/../assets/images/coursepack/lineup/vol06/vol06_cup02_cover04.jpg')}?imageMogr2/format/jpg`,
                  label: require('@/../assets/images/coursepack/lineup/vol06/vol06_cup02_label03.png'),
                  vid: 'l35363albnr',
                  name: 'Wii 彩虹之路'
                }
              ]
            }
          ],
          sectionId: "lineup-6th",
          character: [
            {
              shoulderImg: require('@/../assets/images/coursepack/lineup/vol04/vol04_character_shoulder.png'),
              nameMobileImg: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_name1_sp.png'),
              nameImg: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_name1.png'),
              text1MobileImg: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_text01_sp.png'),
              text1Img: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_text01.png'),
              poster1: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_thumb01.png'),
              poster2: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_thumb02.png'),
              mainMobileImg: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_img01_sp.png'),
              mainImg: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_img01.png')
            },
            {
              nameMobileImg: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_name2_sp.png'),
              nameImg: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_name2.png'),
              text1MobileImg: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_text02_sp.png'),
              text1Img: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_text02.png'),
              poster1: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_thumb03.png'),
              poster2: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_thumb04.png'),
              mainMobileImg: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_img02_sp.png'),
              mainImg: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_img02.png')
            },
            {
              nameMobileImg: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_name3_sp.png'),
              nameImg: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_name3.png'),
              text1MobileImg: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_text02_sp.png'),
              text1Img: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_text02.png'),
              poster1: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_thumb05.png'),
              poster2: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_thumb06.png'),
              mainMobileImg: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_img03_sp.png'),
              mainImg: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_img03.png')
            },
            {
              nameMobileImg: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_name4_sp.png'),
              nameImg: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_name4.png'),
              text1MobileImg: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_text01_sp.png'),
              text1Img: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_text01.png'),
              poster1: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_thumb07.png'),
              poster2: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_thumb08.png'),
              mainMobileImg: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_img04_sp.png'),
              mainImg: require('@/../assets/images/coursepack/lineup/vol06/vol06_character_img04.png')
            },
          ]
        }
      ],
      buyList: [
        {
          key: 'WXSTORE',
          url:
            'https://metadata-images.nintendoswitch.com.cn/formal/8284863422995-DBA7DB86-64AE-3388-2DB4-E704EBFAD599-main-engine.jpg'
        },
        {
          key: 'JD',
          url: 'https://item.jd.com/100017579671.html'
        },
        {
          key: 'TM',
          url:
            'https://nintendoswitchdw.tmall.com/search.htm?spm=a1z10.1-b.w5002-25282588214.1.2c8c3cfaJMhxLS&search=y'
        }
      ],
      videoHeight: 0,
      swiperOption: {
        slidesPerView: 1.7,
        centeredSlides: true,
        wrapperClass: 'course-list',
        allowTouchMove: true,
        touchRatio: 0.5
      },
      swiperSlideWidth: 0
    };
  },
  computed: {
    autoFixVideoStyle() {
      return {
        height: `${this.videoHeight}px`,
        // marginTop: this.isMobile ? '50%' : 0,
        maxHeight: '99vh'
      };
    },
    showPrev() {
      return this.currentSwiper > 0;
    },
    showNext() {
      return this.currentSwiper < this.galleryList.length - 1;
    },
    swiper() {
      return this.$refs.mySwiper ? this.$refs.mySwiper.swiper : null;
    }
    // prevStyle() {
    //   if (this.swiperSlideWidth > 0) {
    //     return {
    //       right: `calc(${this.swiperSlideWidth}px + 1.5rem)`
    //     };
    //   }
    //   return {};
    // },
    // nextStyle() {
    //   if (this.swiperSlideWidth > 0) {
    //     return {
    //       left: `calc(${this.swiperSlideWidth}px + 1.5rem)`
    //     };
    //   }
    //   return {};
    // }
  },
  watch: {
    currentPlayingVideo(newVal, oldVal) {
      if (oldVal !== -1 && newVal === -1) {
        // 销毁视频
        const item = this.galleryList[oldVal];
        const containerId = `gallery-vid-${item.vid}-${oldVal}`;
        document.getElementById(containerId).innerHTML = '';
      }
    }
  },
  created() {
    if (this.$wxSdk) {
      this.$wxSdk.updateShareData({
        title: document.title,
        desc: '马力欧卡丁车8 豪华版 新增赛道通行证',
        imgUrl:
          'https://switch-cn.gtgres.com/subjects/share/mario_kart_8_deluxe.jpg',
        shareLink: window.location.href.replace(window.location.hash, '')
      });
    }
    // queryCdnData()
    //   .then((list) => {
    //     if (list[0] && list[0].urls) {
    //       this.buyList = list[0].urls;
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    window.onresize = () => {
      this.setVideoHeight();
      // this.setSwiperWidth();
    };
    const ua = window.navigator.userAgent.toLowerCase();
    this.isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mi\s|mix\s|redmi/i.test(
      ua
    );
    this.isIOS = /iphone|ipad|ipod/i.test(ua);
    if (this.isMobile) {
      this.swiperOption.slidesPerView = 1.2;
    }
  },
  mounted() {
    this.setVideoHeight();
    function checkWeixinBrowser() {
      const ua = navigator.userAgent;
      const str = ua.match(/MicroMessenger/i);
      if (str && str[0].toLocaleLowerCase() == 'micromessenger') {
        return true;
      }
      return false;
    }
    const isWeixin = checkWeixinBrowser();
    if (isWeixin) {
      // 微信浏览器自动播放视频
      document.addEventListener('touchstart', function () {
        const videos = [...document.getElementsByTagName('video')];
        videos.forEach((v) => {
          if (v.getAttribute('autoplay')) {
            v.play();
          }
        });
      });
      document.addEventListener(
        'WeixinJSBridgeReady',
        function () {
          const videos = [...document.getElementsByTagName('video')];
          videos.forEach((v) => {
            if (v.getAttribute('autoplay')) {
              v.play();
            }
          });
        },
        false
      );
    }
    // this.setSwiperWidth();
  },
  methods: {
    // setSwiperWidth() {
    //   const w = window.innerWidth;
    //   const item = document.getElementsByClassName('swiper-slide')[0];
    //   if (item) {
    //     const width = item.offsetWidth;
    //     if (width > 840) {
    //       this.swiperOption.slidesPerView = (w / 840).toFixed(2);
    //     }
    //   }
    //   console.log(this.swiperOption.slidesPerView);
    //   this.$nextTick(() => {
    //     this.setSlideBtn();
    //   });
    // },
    // setSlideBtn() {
    //   const item = document.getElementsByClassName('swiper-slide')[0];
    //   if (item) {
    //     const width = item.offsetWidth;
    //     const w = window.innerWidth;
    //     this.swiperSlideWidth = (w + width) / 2;
    //   }
    // },
    switchVol(index) {
      if (this.volList[index].published) {
        this.currentIndex = index;
      }
    },
    popMask() {
      // 展开浮层
      this.tempTop =
        document.getElementsByTagName('html')[0].scrollTop ||
        document.scrollingElement.scrollTop;
      // 获取滚动宽度，chrom新增配置，会自动隐藏滚动条
      const paddingRight = getScrollbarWidth();
      document.body.style.overflowY = 'hidden';
      document.body.style.height = 'auto';
      document.body.style.boxSizing = 'border-box';
      if (!this.isMobile) {
        document.body.style.paddingRight = `${paddingRight}px`;
      } else {
        // 苹果手机需要fixed锁定才不会滚动
        document.body.style.width = '100%';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.tempTop}px`;
      }
    },
    closeMask() {
      // 关闭浮层
      document.body.style.overflowY = null;
      document.body.style.height = null;
      document.body.style.boxSizing = null;
      document.body.style.paddingRight = null;
      document.body.style.width = null;
      document.body.style.position = null;
      document.body.style.top = null;
      // ios and android
      document.getElementsByTagName('html')[0].scrollTop = this.tempTop;
      document.scrollingElement.scrollTop = this.tempTop;
    },
    showVideo(vid) {
      this.popMask();
      this.show.video = true;
      setTimeout(() => {
        this.show.video2 = true;
      }, 200);
      this.$nextTick(() => {
        this.setVideoHeight();
      });
      new Txplayer({
        containerId: 'videobox',
        vid,
        width: '100%',
        height: '100%',
        autoplay: true,
        platform: '5410201',
        sdtfrom: 'v1012',
        miniSkinAdaptive: false
      });
      pgvEventReport('mariocart_coursepack.open_kv_video');
    },
    closeVideo() {
      this.show.video = false;
      this.show.video2 = false;
      this.closeMask();
      document.getElementById('videobox').innerHTML = '';
    },
    setVideoHeight() {
      // 计算视频高度，保持比例 1920/1080
      const vWidth = document.getElementById('videobox').offsetWidth;
      this.videoHeight = (1080 / 1920) * vWidth;
    },
    showGallery(vol, match, round) {
      // 读取缓存
      if (this.gallery[vol]) {
        this.galleryList = this.gallery[vol];
      } else {
        this.galleryList = this.initGallery(vol);
      }
      const startIndex = this.getStartIndex(vol, match, round);
      if (startIndex !== 0) {
        this.$nextTick(() => {
          this.swiper && this.swiper.slideTo(startIndex, 0);
        });
      } else {
        this.swiper && this.swiper.slideTo(0, 0);
      }
      pgvEventReport(
        `mariocart_coursepack.open_img_vol${vol}_match${match}_round${round}`
      );
      this.popMask();
      this.show.gallery = true;
      setTimeout(() => {
        this.show.gallery2 = true;
      }, 200);
    },
    closeGallery() {
      document.body.style.overflowY = 'auto';
      document.body.style.height = 'unset';
      this.show.gallery = false;
      this.show.gallery2 = false;
      this.currentPlayingVideo = -1;
      this.closeMask();
    },
    initGallery(vol) {
      // 生成相册
      const { match } = this.volList[vol];
      const round = [];
      match.forEach((m) => {
        round.push(...m.round);
      });
      return round;
    },
    getStartIndex(v, m, r) {
      const { match } = this.volList[v];
      let index = 0;
      for (let i = 0; i < m; i++) {
        index += match[i].round.length;
      }
      index += r;
      return index;
    },
    slideChangeHandler() {
      this.currentSwiper = this.swiper ? this.swiper.activeIndex : 0;
      this.currentPlayingVideo = -1;
    },
    prevHandler() {
      if (this.showPrev) {
        if (this.swiper) {
          this.swiper.slidePrev();
        }
      }
    },
    nextHandler() {
      if (this.showNext) {
        if (this.swiper) {
          this.swiper.slideNext();
        }
      }
    },
    playGalleryVideo(index) {
      if (index === this.currentPlayingVideo) {
        return;
      }
      const item = this.galleryList[index];
      const containerId = `gallery-vid-${item.vid}-${index}`;
      pgvEventReport(`mariocart_coursepack.play_round_video_${item.vid}`);
      new Txplayer({
        containerId,
        vid: item.vid,
        width: '100%',
        height: '100%',
        autoplay: true,
        platform: '5410201',
        sdtfrom: 'v1012',
        miniSkinAdaptive: false
      });
      this.$nextTick(() => {
        this.currentPlayingVideo = index;
      });
    },
    toMoviePage() {
      pgvEventReport('mariocart_coursepack.click_to_movie');
      location.href = '/mario_kart_8_deluxe/coursepack/movie/';
    }
  }
};
</script>
<style>
@keyframes prevHover {
  0% {
    transform: translate3d(0, 0, 0);
  }
  50% {
    transform: translate3d(-5px, 0, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes nextHover {
  0% {
    transform: translate3d(0, 0, 0);
  }
  50% {
    transform: translate3d(5px, 0, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
.c-modal-frame.movie-frame::before {
  display: none;
}
.displayFlex {
  display: flex;
}
.js-hover-button {
  user-select: none;
}
.course-nav-prev .js-hover-button-child:hover {
  animation: prevHover 300ms;
}
.course-nav-next .js-hover-button-child:hover {
  animation: nextHover 300ms;
}
._txplayer_svg_sprite.txp_svg_sprite {
  display: none !important;
}
</style>
